
const ms213 = {
  label: "Account Overdraft",
  pageLabel: "Account Overdraft",
  starting: true,
  url: "ms213",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Filter",
        uid: "filter",
        style: { fontFamily: "verdana" }
      },
      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "filterBranch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "filterBranch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Search",
      label: "Search",
      name: "",
      description: "Enter Search"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Enter Search",
      label: "",
      name: "filterSearch",
      description: "Enter Search"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product-1",
          value: "product-1"
        },
        {
          label: "product-2",
          value: "product-2"
        },
        {
          label: "product-3",
          value: "product-3"
        }
      ],
      placeHolder: "Product",
      //   label: "Branch Code",
      name: "product",
      description: "Enter Product"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Customer Type",
      label: "Customer Type",
      name: "",
      description: "Select Customer Type"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "indivisual",
          value: "indivisual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "Other"
        }
      ],
      placeHolder: "Customer Type",
      //   label: "Branch Code",
      name: "filterCustomertype",
      description: "Select Customer Type"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Customer No",
      label: "Customer No",
      name: "",
      description: "Select Customer No"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "customer-1",
          value: "customer-1"
        },
        {
          label: "customer-2",
          value: "customer-2"
        },
        {
          label: "customer-3",
          value: "customer-3"
        }
      ],
      placeHolder: "Customer Number",
      //   label: "Branch Code",
      name: "filterCustomerNo",
      description: "Select Customer number"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "CustomerNo",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No.",
      label: "Account No.",
      name: "",
      description: "Enter Account No. Text"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Account No",
      label: "",
      name: "filteraccountNo",
      description: "Enter Account No"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Name",
      label: "Name",
      name: "",
      description: "Enter Name"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Name",
      label: "",
      name: "Name",
      description: "Enter Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Number Of Records",
      label: "Number Of Records",
      name: "",
      description: "Enter Number Of Records"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Enter Number Of Records",
      label: "",
      name: "filternumberOfRecords",
      description: "Enter Number Of Records"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: true,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "filteractive",
      description: "Active"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "createBranch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product-1",
          value: "product-1"
        },
        {
          label: "product-2",
          value: "product-2"
        },
        {
          label: "product-3",
          value: "product-3"
        }
      ],
      placeHolder: "Product",
      //   label: "Branch Code",
      name: "createProduct",
      description: "Enter Product"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No.",
      label: "Account No.",
      name: "",
      description: "Account No."
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "account number-1",
          value: "account number-1"
        },
        {
          label: "account number-2",
          value: "account number-2"
        },
        {
          label: "account number-3",
          value: "account number-3"
        }
      ],
      placeHolder: "account number",
      //   label: "Branch Code",
      name: "createAccountnumber",
      description: "Enter Account Number"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "accountnumber",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Date",
      label: "Date",
      name: "",
      description: "Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Date",
      name: "createDate",
      description: "Enter from Date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "From Date",
      label: "From Date",
      name: "",
      description: "From Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "FromDate",
      name: "createFromDate",
      description: "Enter from From Date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "To Date",
      label: "To Date",
      name: "",
      description: "To Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "ToDate",
      name: "createToDate",
      description: "Enter from To Date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Overdraft Amount",
      label: "Overdraft Amount",
      name: "",
      description: "Enter Overdraft Amount"
    },
    {
      inputType: "numberonly",
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Enter Overdraft Amount",
      label: "",
      name: "createAmount",
      description: "Enter Overdraft Amount"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: true,
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "createactive",
      description: "Active"
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Branch",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "A/c No",
        accessor: "email"
      },
      {
        Header: "Name",
        accessor: "mobile"
      },
      {
        Header: "Start Date",
        accessor: "pfnumber"
      },
      {
        Header: "End Date",
        accessor: "EmployeeID"
      },
      {
        Header: "Amount",
        accessor: "EmployeeID"
      },
      {
        Header: "Remarks",
        accessor: "EmployeeID"
      }
    ]
  }
};

export default ms213;
